import { render, staticRenderFns } from "./backBtn.vue?vue&type=template&id=6396db46&scoped=true&"
import script from "./backBtn.vue?vue&type=script&lang=js&"
export * from "./backBtn.vue?vue&type=script&lang=js&"
import style0 from "./backBtn.vue?vue&type=style&index=0&id=6396db46&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6396db46",
  null
  
)

export default component.exports